module.exports = __webpack_public_path__ + "78af8e87862dbf71530a2b07a30553b9.png";